import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const FilterControls = ({ 
  sortBy, 
  onSortChange, 
  priceFilter, 
  onPriceFilterChange,
  ratingFilter,
  onRatingFilterChange,
  availabilityFilter,
  onAvailabilityFilterChange,
  onResetFilters
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-slate-100 p-4 mb-6">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        {/* Sort Dropdown */}
        <div className="flex items-center gap-3">
          <Icon name="SlidersHorizontal" size={20} className="text-slate-600" />
          <Select
            value={sortBy}
            onChange={(e) => onSortChange(e?.target?.value)}
            className="min-w-[200px] border-slate-200"
          >
            <option value="relevance">الأكثر ملاءمة</option>
            <option value="rating">الأعلى تقييماً</option>
            <option value="price-low">السعر: من الأقل للأعلى</option>
            <option value="price-high">السعر: من الأعلى للأقل</option>
            <option value="experience">الأكثر خبرة</option>
          </Select>
        </div>

        {/* Filter Toggle Button */}
        <Button
          variant="outline"
          onClick={() => setIsOpen(!isOpen)}
          iconName={isOpen ? 'ChevronUp' : 'ChevronDown'}
          iconPosition="right"
          className="border-slate-300"
        >
          تصفية النتائج
        </Button>
      </div>

      {/* Expandable Filters */}
      {isOpen && (
        <div className="mt-4 pt-4 border-t border-slate-100 grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Price Range */}
          <div>
            <label className="text-sm font-medium text-slate-700 mb-2 block">نطاق السعر</label>
            <div className="flex items-center gap-2">
              <input
                type="number"
                value={priceFilter?.min}
                onChange={(e) => onPriceFilterChange({ ...priceFilter, min: Number(e?.target?.value) })}
                placeholder="من"
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm"
              />
              <span className="text-slate-400">-</span>
              <input
                type="number"
                value={priceFilter?.max}
                onChange={(e) => onPriceFilterChange({ ...priceFilter, max: Number(e?.target?.value) })}
                placeholder="إلى"
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm"
              />
            </div>
          </div>

          {/* Rating Filter */}
          <div>
            <label className="text-sm font-medium text-slate-700 mb-2 block">التقييم</label>
            <Select
              value={ratingFilter}
              onChange={(e) => onRatingFilterChange(Number(e?.target?.value))}
              className="border-slate-200"
            >
              <option value={0}>جميع التقييمات</option>
              <option value={4.5}>4.5+ نجوم</option>
              <option value={4}>4+ نجوم</option>
              <option value={3.5}>3.5+ نجوم</option>
            </Select>
          </div>

          {/* Availability Filter */}
          <div>
            <label className="text-sm font-medium text-slate-700 mb-2 block">التوفر</label>
            <Select
              value={availabilityFilter}
              onChange={(e) => onAvailabilityFilterChange(e?.target?.value)}
              className="border-slate-200"
            >
              <option value="all">الكل</option>
              <option value="available">متاح الآن</option>
              <option value="busy">مشغول</option>
            </Select>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterControls;